import { useEffect, useRef, useState } from "react";
import { randomSequentialId } from "util/utils";

function localSocket() {
  this.callbacks = [];

  if (!this)
    throw new Error(
      " Failed to construct 'LocalSocket': Please use the 'new' operator, this object constructor cannot be called as a function."
    );

  this.connections = [];
  this.connectionId = randomSequentialId();

  this.connected = true;
  this.on = (event, cb) => {
    if (!this.connected) return;
    const isList = Array.isArray(event);
    return this.callbacks.push({
      event: isList ? event.map((e) => e.trim()).join(" ") : String(event),
      cb: typeof cb === "function" ? cb : () => {},
      callable: true,
      callType: "on",
      isTrainOfEvent: isList,
      ...(isList && {
        eventCount: event.length,
        matchCount: 0,
        registered: "",
      }),
    });
  };

  this.once = (event, cb) => {
    if (!this.connected) return;

    const isList = Array.isArray(event);
    return this.callbacks.push({
      event: isList ? event.map((e) => e.trim()).join(" ") : String(event),
      cb,
      callable: true,
      isTrainOfEvent: isList,
      callType: "once",
      ...(isList && {
        eventCount: event.length,
        matchCount: 0,
        registered: "",
      }),
    });
  };
  this.emit = (event, args) => {
    if (!this.connected) return;

    let index = 0;
    for (const c of this.callbacks) {
      const eventMatch = !c.isTrainOfEvent
        ? c.event === event
        : String(c.registered + ` ${event}`).trim() === event;

      if (eventMatch && c.callable && c.cb && typeof c.cb === "function") {
        if (c.callType === "on") {
          c.cb(args);
        } else if (c.callType === "once" && !c.callType.called) {
          this.callbacks[index].called = true;
          c.cb(args);
        }
      }

      if (!eventMatch && c.isTrainOfEvent) {
        const currentRegister = c.registered;
        const firstRegister = !c.registered;
        if (firstRegister) {
          if (event.startsWith(event))
            this.callbacks[index].registered = String(event).trim();
        } else {
          if (c.event.includes(currentRegister + ` ${event}`)) {
            this.callbacks[index].registered =
              currentRegister + ` ${String(event).trim()}`;
          }
        }
      } else if (c.isTrainOfEvent) {
        this.callbacks[index].registered = "";
      }
      index++;
    }
  };
  this.off = (index) => {
    if(!index || !this.callbacks[index]) return;
    this.callbacks[index].callable = false;
  };
  this.reOn = (index) => {
    if (!this.connected) return;
    if(!index || !this.callbacks[index]) return;
    this.callbacks[index].callable = true;
  };
  this.connect = () => {
    this.connected = true;
    this.emit("connect", {
      connectionId: this.connectionId,
      connections: this.connections,
      connected: this.connected,
    });
  };

  this.disconnect = () => {
    if (!this.connected) return;
    this.connected = false;
    this.emit("disconnect", {
      connectionId: this.connectionId,
      connections: this.connections,
      connected: this.connected,
    });
  };

  return this.emit("connect", {
    connectionId: this.connectionId,
    connections: this.connections,
    connected: this.connected,
  });
}

export function useLocalSocket(url) {
  const [socket, setSocket] = useState(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      const ssocket = new localSocket();
      if (ssocket) {
        setSocket(ssocket);
        initialized.current = true;
        ssocket.on("connect", () => {
          console.log("connected to localSocket");
        });

        ssocket.on("disconnect", () => {
          console.log("disconnected from localSocket");
        });
      }
    }
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    function handleFocus() {
      console.log("localSocket reconnected");
      socket && socket.connect();
    }
    function handleBlur() {
      socket && socket.disconnect();
    }

    function cleanup() {
      socket && socket?.disconnect && socket?.disconnect();
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
    }
    return cleanup;
  }, [socket]);

  return socket;
}
